/**
 * Results sections
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function ResultsSection({ title, content }) {
  return (
    <div
      className={classnames({
        'result-group': true,
      })}
    >
      <h5>
        {title}
      </h5>
      <div>
        <div>
          {content}
        </div>
      </div>
    </div>
  );
}

ResultsSection.propTypes = {
  content: PropTypes.shape({}),
  title: PropTypes.string,
};

export default ResultsSection;



// WEBPACK FOOTER //
// js/src/goals/ResultsSection.js